import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';

export const prev_spostamento_iscritto_table_keys: ITableKey[] = [
  {
    label: 'Datore',
    key: 'employerCode',
  },
  {
    label: 'Ragione Sociale',
    key: 'socialReason',
  },
  {
    label: 'Convenzionato',
    key: 'conventioned',
    type: 'GENERIC_BADGE',
  },
  {
    label: 'Stato Datore',
    key: 'employerState',
  },
  {
    label: 'Individuale Pura',
    type: 'CHECKBOX',
    key: 'isPure',
    isDisabledKey: 'isPureDisabled'
  },
  {
    label: 'Chiudi Datore',
    type: 'CHECKBOX',
    key: 'closeEmployer'
  },
  {
    label: 'Riattiva Datore',
    type: 'CHECKBOX',
    key: 'reopenEmployer'
  },
  {
    label: 'Switch Confermato',
    key: 'switchConfirmed',
    type: 'GENERIC_BADGE',
    defaultValue: 'N'
  },
];

export interface ISpostamentoIscrittoRequest {
  policyNumber: string;
  employers: SpostamentoIscrittoEmployersRequest[];
}

export interface SpostamentoIscrittoEmployersRequest {
  closeEmployer: string;
  conventioned: boolean;
  registryId: string;
  socialReason: string;
  pIVA: boolean;
  employerCode: boolean;
  isPure: boolean;
  newRegistryId?: string;
  newEmployerCode?: string;
  newPIVA?: string;
  newSocialReason?: string;
  newConventioned: boolean;
  wasPure: boolean;
  state: string;
  productCode: string;
}

export interface EmployerTableRow {
  employer: string | null;
  socialReason: string | null;
  conventioned: string | null;
  employerState: string | null;
  isPure?: boolean | null;
  closeEmployer?: boolean | null;
  reopenEmployer?: boolean | null;
}
